import Vue from 'vue';
import App from './App.vue';
import router from './router';
import i18n from '@/lang';
import '@/assets/style/base.scss';
import '@/assets/style/normalize.css';
// import '@/utils/class_component_hooks';
import '@/utils/element-ui-setting'
import SvgIcon from 'vue-svgicon';
import '@/icons/components';

Vue.use(SvgIcon, {
  tagName: 'svg-icon',
  defaultWidth: '18px',
  defaultHeight: '18px',
});

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  render: (h) => h(App)
}).$mount('#app');
